export default "__VITE_ASSET__5OxySBAn__"